import { useQueryParams } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { omit, omitBy } from 'lodash-es';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { FilterMenu } from 'features/filter_menu';
import { FILTER_PARAMS_HOSTS, FILTER_PARAMS_OWNERS, FILTER_PARAMS_PERMISSION, FILTER_PARAMS_USERS } from './constants';
import { DropdownContent } from './dropdown_content';
import { Icon } from './icon';
import { pushQueryParams } from '../../actions/core/navigation';
const containerCss = "c1hna1rs";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const filterByCss = "f5333w5";
const FilterBy = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filterByCss, props.className)} />;
});
const getButtonText = appliedFilters => <FilterBy>
    <BodyText inline as="div">{I18n.t('publisher.event_types.filters.button')}</BodyText>
    {appliedFilters > 0 && <BodyText inline as="div">
      (
      {appliedFilters}
      )
    </BodyText>}
  </FilterBy>;
const getNumericFilters = (params, key) => params[key]?.map(Number) || [];
export const FiltersButton = ({
  scopeOverride
}) => {
  const params = useQueryParams();
  const dispatch = useDispatch();
  const hostIds = getNumericFilters(params, FILTER_PARAMS_HOSTS);
  const ownerIds = getNumericFilters(params, FILTER_PARAMS_OWNERS);
  const userIds = getNumericFilters(params, FILTER_PARAMS_USERS);
  const permission = params[FILTER_PARAMS_PERMISSION] || '';
  const appliedFilters = [hostIds, ownerIds, userIds].filter(items => items.length > 0).length + (permission ? 1 : 0);
  const [toggleDropdown, Wrapper, isOpen] = useDropdown();
  const onClear = () => {
    const searchParams = omit(params, [FILTER_PARAMS_HOSTS, FILTER_PARAMS_OWNERS, FILTER_PARAMS_USERS, FILTER_PARAMS_PERMISSION]);
    dispatch(pushQueryParams(searchParams));
  };
  const onCancel = () => {
    toggleDropdown();
  };
  const onSearch = ({
    selectedHostIds,
    selectedOwnerIds,
    selectedUserIds,
    selectedPermission
  }) => {
    const searchParams = omitBy({
      ...params,
      [FILTER_PARAMS_HOSTS]: selectedHostIds,
      [FILTER_PARAMS_OWNERS]: selectedOwnerIds,
      [FILTER_PARAMS_USERS]: selectedUserIds,
      [FILTER_PARAMS_PERMISSION]: selectedPermission
    }, value => value.length === 0);
    dispatch(pushQueryParams(searchParams));
    toggleDropdown();
  };
  return <Container>
      <FilterMenu buttonText={getButtonText(appliedFilters)} hasSelection={appliedFilters > 0} CustomIcon={Icon} isOpen={isOpen} onClick={toggleDropdown} Wrapper={Wrapper} data-calendly-label="filter-button" isContainerResponsive={false}>
        <DropdownContent initialHostIds={hostIds} initialOwnerIds={ownerIds} initialUserIds={userIds} initialPermission={permission} onSearch={onSearch} onCancel={onCancel} scopeOverride={scopeOverride} />
      </FilterMenu>
      {appliedFilters > 0 && <div>
          <MinimalButton onClick={onClear}>
            {I18n.t('publisher.event_types.filters.clear')}
          </MinimalButton>
        </div>}
    </Container>;
};

require("./filters_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filters_button.js");